import { Badge, Button, Card } from '@/components/ui';
import { cn } from '@/utils/cn';

import { entitlementLines, formatPrice } from './money';

/**
 * One plan, its price and exactly what it grants.
 *
 * The entitlement list comes from the API rather than from copy written here,
 * so the pricing page cannot drift from what the backend enforces. That has
 * happened to every product that hard-coded its own feature bullets.
 */
export function PlanCard({ plan, onChoose, isBusy, action, className }) {
  const current = plan.is_current;

  return (
    <Card
      className={cn(
        'flex flex-col',
        current ? 'border-brand-300 shadow-card' : undefined,
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-ink font-semibold">{plan.name}</h3>
        {current && <Badge tone="brand">Your plan</Badge>}
      </div>

      <p className="text-ink mt-4 text-3xl font-semibold">
        {formatPrice(plan.price_cents, plan.currency, plan.interval)}
      </p>
      {plan.description && <p className="text-ink-muted mt-2 text-sm">{plan.description}</p>}

      <ul className="mt-5 space-y-2">
        {entitlementLines(plan.entitlements).map((line) => (
          <li key={line} className="text-ink-muted flex gap-2 text-sm">
            <span className="text-brand-600" aria-hidden="true">
              ✓
            </span>
            {line}
          </li>
        ))}
      </ul>

      <div className="mt-6 grow" />
      {action ?? (
        <Button
          variant={current ? 'secondary' : 'primary'}
          className="w-full"
          disabled={current || isBusy}
          isLoading={isBusy}
          onClick={() => onChoose?.(plan)}
        >
          {current ? 'Current plan' : `Move to ${plan.name}`}
        </Button>
      )}
    </Card>
  );
}
